import React from 'react';
import styled from 'styled-components';
import triangle from './triangle.png';

const Container = styled.div`
    position: relative;
    font-weight: bold;
    font-size: 14px;
    text-align: center;
`;

const Triangle = styled.img`
    display: inline-block;
    width: 20px;
    height: 20px;

`;

const Title1 = styled.div`
    color: rgb(252, 205, 0);
`;

const Title2 = styled.div`
    color: white;
`;

export default () => (
  <Container>
    <Triangle src={triangle} alt="" />
    <Triangle src={triangle} alt="" />
    <Triangle src={triangle} alt="" />
    <Title1>購餐 | 取貨</Title1>
    <Title2>開門123</Title2>
  </Container>
);
